import React from 'react'
import { Menu } from '@mui/material'


const AnchorMenu = ({anchorEl, anchorOrigin, transformOrigin, onClose, children}) => (
    <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClose={onClose}
    >
        {children}
    </Menu>
)

export default AnchorMenu
